import React from "react";
import SubmittedAgreement from "../../sumitted_agreement/SubmittedAgreement";

const UnauthorizedApprovedAgreement = () => {
  const fileStatus = 30;
  const applicationPath = {
    copyright: "/admin/unauthorized-approved-copyright",
    agreement: "/admin/unauthorized-approved-agreement",
  };
  
  // Add route to details page
  const detailsRoute = "/admin/unauthorized-agreement-details";
  const pageTitle = "অননুমোদন অনুমোদিত";

  return (
    <SubmittedAgreement
      fileStatus={fileStatus}
      applicationPath={applicationPath}
      detailsRoute={detailsRoute}
      pageTitle={pageTitle}
    />
  );
};

export default UnauthorizedApprovedAgreement;
